module.exports = __webpack_public_path__ + "media/packs/images/flags/KE-0f5d1e80ed289b156414728af5411306.png";